import React from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '../components/DataTable';
import { Plus, Users, BarChart2 } from 'lucide-react';
const Personas: React.FC = () => {
  const navigate = useNavigate();
  const columns = [{
    key: 'name',
    label: 'Persona Name',
    sortable: true
  }, {
    key: 'type',
    label: 'Type',
    sortable: true
  }, {
    key: 'description',
    label: 'Description',
    sortable: true
  }, {
    key: 'count',
    label: 'Count',
    sortable: true
  }, {
    key: 'createdAt',
    label: 'Created',
    sortable: true
  }, {
    key: 'status',
    label: 'Status',
    sortable: true,
    render: (value: string) => <div className="flex items-center" data-id="element-1443">
          {value === 'Active' && <span className="mr-2 w-2 h-2 rounded-full bg-green-500" data-id="element-1444"></span>}
          <span data-id="element-1445">{value}</span>
        </div>
  }];
  const mockData = [{
    id: 1,
    name: 'Enterprise Customers',
    type: 'Account',
    description: 'Accounts with over 100 users',
    count: 12,
    createdAt: 'Jan 15, 2023',
    status: 'Active'
  }, {
    id: 2,
    name: 'Power Users',
    type: 'User',
    description: 'Users with 50+ sessions per month',
    count: 78,
    createdAt: 'Feb 3, 2023',
    status: 'Active'
  }, {
    id: 3,
    name: 'New Accounts',
    type: 'Account',
    description: 'Accounts created in last 30 days',
    count: 24,
    createdAt: 'Mar 10, 2023',
    status: 'Active'
  }, {
    id: 4,
    name: 'Admins',
    type: 'User',
    description: 'Users with admin permissions',
    count: 45,
    createdAt: 'Apr 22, 2023',
    status: 'Active'
  }, {
    id: 5,
    name: 'At-Risk Accounts',
    type: 'Account',
    description: 'Accounts with decreasing usage',
    count: 8,
    createdAt: 'May 5, 2023',
    status: 'Active'
  }, {
    id: 6,
    name: 'Report Creators',
    type: 'User',
    description: 'Users who create reports regularly',
    count: 36,
    createdAt: 'Jun 18, 2023',
    status: 'Active'
  }, {
    id: 7,
    name: 'Healthcare Industry',
    type: 'Account',
    description: 'Accounts in healthcare sector',
    count: 15,
    createdAt: 'Jul 7, 2023',
    status: 'Active'
  }, {
    id: 8,
    name: 'Inactive Users',
    type: 'User',
    description: 'Users without activity in 14+ days',
    count: 29,
    createdAt: 'Aug 12, 2023',
    status: 'Active'
  }];
  const handleRowClick = (persona: any) => {
    navigate(`/personas/${persona.id}`);
  };
  return <div className="space-y-6" data-id="element-1446">
      <div className="flex justify-between items-center" data-id="element-1447">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1448">Personas</h1>
        <button className="bg-[#0070d2] hover:bg-[#0057a3] text-white px-4 py-2 rounded-md flex items-center gap-2" data-id="element-1449">
          <Plus size={18} data-id="element-1450" />
          <span data-id="element-1451">New Persona</span>
        </button>
      </div>
      <div className="grid grid-cols-3 gap-4" data-id="element-1452">
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm" data-id="element-1453">
          <div className="flex items-center gap-3" data-id="element-1454">
            <div className="p-2 rounded-full bg-blue-100 text-blue-600" data-id="element-1455">
              <Users size={20} data-id="element-1456" />
            </div>
            <div data-id="element-1457">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-1458">
                Total Personas
              </h3>
              <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1459">8</p>
            </div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm" data-id="element-1460">
          <div className="flex items-center gap-3" data-id="element-1461">
            <div className="p-2 rounded-full bg-green-100 text-green-600" data-id="element-1462">
              <Users size={20} data-id="element-1463" />
            </div>
            <div data-id="element-1464">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-1465">
                Account Personas
              </h3>
              <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1466">4</p>
            </div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm" data-id="element-1467">
          <div className="flex items-center gap-3" data-id="element-1468">
            <div className="p-2 rounded-full bg-purple-100 text-purple-600" data-id="element-1469">
              <Users size={20} data-id="element-1470" />
            </div>
            <div data-id="element-1471">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-1472">
                User Personas
              </h3>
              <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1473">4</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-md border border-gray-200 shadow-sm overflow-hidden" data-id="element-1474">
        <DataTable columns={columns} data={mockData} onRowClick={handleRowClick} data-id="element-1475" />
      </div>
      <div className="grid grid-cols-2 gap-6" data-id="element-1476"></div>
    </div>;
};
export default Personas;